
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Proxying on the Edge: Part 2";
export const tags = ["Devlog", "Update", "Web Proxies"];
export const description = "Notes on developing the Infrared edge proxy and adding TompHTTP V3 support.";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h2, {
      children: "Recap"
    }), "\n", _jsx(_components.p, {
      children: "Recently, I made a proof-of-concept edge proxy called Superposition. It was very unpolished, and served only as a proof-of-concept."
    }), "\n", _jsx(_components.h2, {
      children: "Infrared"
    }), "\n", _jsxs(_components.p, {
      children: ["In ", _jsx(_components.a, {
        href: "/blog/cf-workers-proxy-part-1.html",
        children: "my last post"
      }), " on this topic, I mentioned I was working on a new proxy called Infrared. I am proud to announce that I have officially released it, and you can visit it at ", _jsx(_components.a, {
        href: "https://infrared.bomberfish.ca",
        children: "infrared.bomberfish.ca"
      }), ". This post will explain the challenges behind creating a proxy like this."]
    }), "\n", _jsx(_components.h2, {
      children: "TompHTTP"
    }), "\n", _jsxs(_components.p, {
      children: ["Since my last proxy was so unpolished, I made sure Infrared conformed to a popular proxy standard. Thankfully, the ", _jsx(_components.a, {
        href: "https://github.com/TompHTTP",
        children: "TompHTTP"
      }), " standard proved popular enough."]
    }), "\n", _jsx(_components.h2, {
      children: "bare-server-worker"
    }), "\n", _jsxs(_components.p, {
      children: ["It turned out that work was already done for porting the TompHTTP bare-server to the Workers runtime, called ", _jsx(_components.code, {
        children: "bare-server-worker"
      }), ". However, this implementation was not maintained, so it only supported the older V2 standard."]
    }), "\n", _jsx(_components.h2, {
      children: "Adding V3"
    }), "\n", _jsxs(_components.p, {
      children: ["Adding support for the newer V3 standard was trivial, as the only major change was merging the old URL segment headers into a new header, named ", _jsx(_components.code, {
        children: "x-bare-url"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      children: "Frontend"
    }), "\n", _jsxs(_components.p, {
      children: ["I opted to use ", _jsx(_components.a, {
        href: "https://github.com/titaniumnetwork-dev/Ultraviolet",
        children: "Ultraviolet"
      }), " as my bare client, as it was well-maintained and had a large userbase. For the webpage, I used a heavily-modified version of ", _jsx(_components.a, {
        href: "https://github.com/titaniumnetwork-dev/Ultraviolet-Static",
        children: "Ultraviolet-Static"
      }), ", as it was written in vanilla HTML."]
    }), "\n", _jsx(_components.h2, {
      children: "Hosting"
    }), "\n", _jsx(_components.p, {
      children: "For hosting the website, I decided to use Cloudflare Pages, as hosting both backend and frontend on Cloudflare's edge network would reduce the chance of the frontend being blocked via IP address (versus GitHub Pages, which was my host of choice)"
    }), "\n", _jsx(_components.h2, {
      children: "What next?"
    }), "\n", _jsx(_components.p, {
      children: "I plan on adding search suggestions and overall improving user experience."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	